// ------------------------------------------------------------------------------
// name: activity
// author: mudas
// created: 2025/6/17
// ------------------------------------------------------------------------------

import { ROUTER_PATHNAME } from 'common/router/routes';

export const useActivityScene = () => {
  const { pathname } = window.location; // Route 范围外的 layout 只能使用全局数据，不能使用 useLocation
  const isActivityScene = pathname.startsWith(`/${ROUTER_PATHNAME.ACTIVITY}`);

  return { isActivityScene };
};
